import styled from 'styled-components';
import * as Parent from '../Base/style';

export const ChatWrapper = styled(Parent.ChatWrapper)``;
